import { Link } from "react-router-dom";
import { MapPin, Building2, Tag, HandHelping, Users } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { NetworkActions } from "@/components/NetworkActions";
import { VerifiedBadge, getTier } from "@/components/VerifiedBadge";

const FALLBACK = "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGZhY2FkZXxlbnwwfHx8fDE3ODgwOTU3MDJ8MA&ixlib=rb-4.1.0&q=85";

export const DiscoverCard = ({ business, onChange }) => {
  const cover = mediaUrl(business.cover_url) || FALLBACK;
  const logo = mediaUrl(business.logo_url);
  return (
    <div data-testid={`discover-card-${business.id}`} className="group flex flex-col bg-white border border-slate-200 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-lg hover:border-slate-300">
      <div className="h-20 w-full overflow-hidden bg-slate-100 relative">
        <img src={cover} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-90" />
        {getTier(business) !== "basic" && (
          <span className="absolute top-2 right-2">
            <VerifiedBadge tier={getTier(business)} size="sm" />
          </span>
        )}
      </div>
      <div className="px-5 pb-5">
        <div className="-mt-7 mb-3 relative z-10 h-14 w-14 rounded-xl border-4 border-white bg-white shadow-sm overflow-hidden flex items-center justify-center">
          {logo ? <img src={logo} alt="" className="h-full w-full object-cover" /> : <Building2 className="text-slate-300" size={22} />}
        </div>

        <Link to={`/business/${business.slug || business.id}`} className="block">
          <h3 className="font-display font-bold text-base text-slate-900 leading-tight hover:text-brand transition-colors line-clamp-1">{business.business_name}</h3>
        </Link>
        {business.trade_name && <p className="text-xs text-slate-400 line-clamp-1">{business.trade_name}</p>}

        <div className="mt-2 flex items-center gap-2 flex-wrap text-xs">
          <span className="font-bold uppercase tracking-wide text-brand">{business.category}</span>
          {(business.city || business.state) && (
            <span className="inline-flex items-center gap-1 text-slate-500"><MapPin size={12} /> {[business.city, business.state].filter(Boolean).join(", ")}</span>
          )}
        </div>

        {business.description && <p className="mt-2 text-sm text-slate-600 line-clamp-2">{business.description}</p>}

        {business.products?.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-1">
            {business.products.slice(0, 3).map((p, i) => (
              <span key={`${p}-${i}`} className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600">{p}</span>
            ))}
          </div>
        )}

        <div className="mt-3 flex items-center gap-3 text-[11px] text-slate-400 font-medium">
          <span className="inline-flex items-center gap-1"><Users size={12} /> {business.follower_count} followers</span>
          {business.has_offer && <span className="inline-flex items-center gap-1 text-emerald-600"><Tag size={12} /> Offers</span>}
          {business.has_requirement && <span className="inline-flex items-center gap-1 text-amber-600"><HandHelping size={12} /> Requirements</span>}
        </div>

        <div className="mt-4">
          <NetworkActions business={business} onChange={onChange} />
        </div>
      </div>
    </div>
  );
};
